import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageKey } from '../../core/constants/local-storage-keys';

@Injectable({
  providedIn: 'root',
})
export class WalkTroughPopoverService {
  private index$ = new BehaviorSubject<number>(null);
  private walkTroughGroupId: string;
  private walkTroughIds = [];
  private completedWalkTroughs = [];

  listen() {
    return this.index$;
  }

  start(walkTroughGroupId: string, walkTroughIds: string[]) {
    this.completedWalkTroughs =
      localStorage.getItem(LocalStorageKey.WT_COMPLETED)?.split(',') ?? [];
    if (!this.completedWalkTroughs.includes(walkTroughGroupId)) {
      this.walkTroughGroupId = walkTroughGroupId;
      this.walkTroughIds = walkTroughIds ?? [];
      this.next(0);
    }
  }

  next(index?: number) {
    index = index ?? this.index$.value + 1;
    if (index < this.walkTroughIds.length) {
      this.index$.next(index);
    } else if (index === this.walkTroughIds.length) {
      this.complete();
    }
  }

  getWalkTroughId() {
    return this.walkTroughIds[this.index$.value];
  }

  getStep() {
    return this.index$.value + 1;
  }

  getTotalSteps() {
    return this.walkTroughIds.length;
  }

  complete() {
    this.completedWalkTroughs.push(this.walkTroughGroupId);
    localStorage.setItem(
      LocalStorageKey.WT_COMPLETED,
      this.completedWalkTroughs.toString()
    );
    this.clear();
  }

  clear() {
    this.walkTroughGroupId = null;
    this.walkTroughIds = [];
    this.index$.next(null);
  }
}
